<template>
	<div id="app" :class="[this.$store.state.device]">
		<nav id="nav" ref="navigation">
			<h1 class="logo" ref="logo">
				<router-link to="/"
					><img src="@/assets/images/img-logo@2x.png" alt="두손소프트"
				/></router-link>
			</h1>
			<div class="wrapGnbMenus">
				<router-link class="gnbMenu" to="/company">COMPANY</router-link>
				<router-link class="gnbMenu" to="/business">BUSINESS</router-link>
				<router-link class="gnbMenu" to="/news">NEWS</router-link>
				<router-link class="gnbMenu" to="/career">CAREER</router-link>
			</div>
			<div class="buttons" ref="btnMobileGnb">
				<b-button
					class="btnMenu"
					type="is-primary"
					size="is-medium"
					:icon-right="gigaMenuActive ? 'close' : 'menu'"
					inverted
					@click="gigaMenuActive = !gigaMenuActive"
				/>
			</div>

			<!-- 기가 메뉴 -->
			<div class="gigaMenu" :class="{ on: gigaMenuActive }">
				<ul class="menuListWrap">
					<li class="home">
						<h2><router-link class="gnbMenu" to="/">HOME</router-link></h2>
					</li>
					<li class="company">
						<h2>
							<router-link class="gnbMenu" to="/company">COMPANY</router-link>
						</h2>
						<ul class="innerMenu">
							<template v-for="(menu, index) in gnbList.menuList[0].subMenu">
								<li
									:key="index"
									:class="{
										mobileHide: menu.mobileHide,
										tabletHide: menu.tabletHide,
										pcHide: menu.pcHide
									}"
								>
									<router-link
										class="gnbSubMenuLink"
										:to="menu.link ? menu.link : ''"
										>{{ menu.txt }}</router-link
									>
								</li>
							</template>
						</ul>
					</li>
					<li class="business">
						<h2>
							<router-link class="gnbMenu" to="/business">BUSINESS</router-link>
						</h2>
						<div class="menuCategory portfolio">
							<h3>
								<router-link class="gigaMenuCategory" to="/portfolio">{{
									gnbList.menuList[1].subCategory[0].txt
								}}</router-link>
							</h3>
							<ul class="innerMenu">
								<li
									v-for="(menu, index) in gnbList.menuList[1].subCategory[0]
										.subMenu"
									:key="index"
								>
									<router-link
										class="gnbSubMenuLink"
										:to="menu.link ? menu.link : ''"
										>{{ menu.txt }}</router-link
									>
								</li>
							</ul>
						</div>
						<div class="menuCategory solution">
							<h3>
								<router-link class="gigaMenuCategory" to="/solution">{{
									gnbList.menuList[1].subCategory[1].txt
								}}</router-link>
							</h3>
							<ul class="innerMenu">
								<li
									v-for="(menu, index) in gnbList.menuList[1].subCategory[1]
										.subMenu"
									:key="index"
								>
									<router-link
										class="gnbSubMenuLink"
										:to="menu.link ? menu.link : '#none'"
										>{{ menu.txt }}</router-link
									>
								</li>
							</ul>
						</div>
					</li>
					<li class="news">
						<h2><router-link class="gnbMenu" to="/news">NEWS</router-link></h2>
						<ul class="innerMenu">
							<li
								v-for="(menu, index) in gnbList.menuList[2].subMenu"
								:key="index"
							>
								<router-link
									class="gnbSubMenuLink"
									:to="menu.link ? menu.link : '#none'"
									>{{ menu.txt }}</router-link
								>
							</li>
						</ul>
					</li>
					<li class="career">
						<h2>
							<router-link class="gnbMenu" to="/career">CAREER</router-link>
						</h2>
						<ul class="innerMenu">
							<li></li>
						</ul>
					</li>
				</ul>
			</div>
		</nav>
		<!-- 라우터 영역 -->
		<router-view :key="$route.fullPath" />
	</div>
</template>

<script>
import { EventBus } from "./utils/event-bus.js";
import { TweenMax, Power2 } from "gsap";
// import gnbData from '@/json/gnb.json'
import PortfolioModal from "./components/PortfolioModal";

export default {
	name: "home",
	components: {},
	data() {
		return {
			wH: 0,
			dH: 0,
			wW: 0,
			gigaMenuActive: false,
			gigiMenuSetTime: 0,
			basicData: {}
		};
	},
	created: function() {
		this.$store.dispatch("getGnb"); // gnb =>  getGnb actions으로 store data를 변경
		window.addEventListener("resize", this.onWinResize);
		window.addEventListener("orientationchange", this.onOrientationChange);
		this.onWinResize();
		this.onOrientationChange();
		EventBus.$on("giga-open", this.openGigaMenu);

		// 포트폴리오 팝업
		EventBus.$on("portfolio-popup-open", data => {
			this.$buefy.modal.open({
				parent: this,
				component: PortfolioModal,
				hasModalCard: true,
				props: {
					item: data
				}
			});
		});
	},
	destroyed: function() {
		EventBus.$off("giga-open", this.openGigaMenu);
		EventBus.$off("portfolio-popup-open");
	},
	computed: {
		gnbList() {
			return this.$store.state.gnb;
		}
	},
	mounted() {
		// console.log('> App.vue> mounted')
		this.dH = document.body.scrollHeight;
		this.wH = window.innerHeight;
		this.wW = window.innerWidth;
		document.addEventListener("click", this.checkGigaMenu);
		document.addEventListener("mousemove", this.mouseMoveHandler);
		TweenMax.to(".logo", 1.2, { opacity: 1, ease: Power2.easeInOut });
		document.documentElement.addEventListener(
			"touchstart",
			function(event) {
				if (event.touches.length > 1) {
					event.preventDefault();
				}
			},
			false
		);

		this.$axios
			.post(this.$store.state.dataUrl + "/twosonConfig")
			.then(response => {
				console.log("basic data : ", response.data);
				this.$store.state.basicInfo = response.data;
				this.basicData = response.data;
				EventBus.$emit("basicinfo-load-complete", response.data.youtube);
			})
			.catch(error => {
				console.log("* basic data error : ", error.response);
			});
	},
	methods: {
		mouseMoveHandler(event) {
			// pc일 경우 기가메뉴 작동 컨트롤
			if (this.$store.state.gnbMode === "pc") {
				if (this.checkGigaHit(event.clientY)) {
					this.gigaMenuActive = true;
				} else {
					this.gigaMenuActive = false;
				}
			}
		},
		onWinResize() {
			this.wW = window.innerWidth;
			this.wH = window.innerHeight;
			console.log(this.wW);
			if (
				(this.wW < 813 && this.wH < 482) ||
				(this.wW < 482 && this.wH < 813)
			) {
				this.$store.commit("currentDevice", "mobile");
				this.$store.commit("currentHeight", "");
			} else if (
				(this.wW < 1025 && this.wH < 769) ||
				(this.wW < 769 && this.wH < 1025)
			) {
				this.$store.commit("currentDevice", "tablet");
				this.$store.commit("currentHeight", "");
			} else {
				this.$store.commit("currentDevice", "pc");
				if (this.wH < 900) {
					console.log(this.wH);
					this.$store.commit("currentHeight", "short");
				} else {
					this.$store.commit("currentHeight", "");
				}
			}
			if (
				this.$device.iphone ||
				this.$device.mobile ||
				this.$device.androidPhone
			) {
				this.$store.commit("currentDevice", "mobile");
			} else if (this.$device.ipad) {
				this.$store.commit("currentDevice", "tablet");
			}

			// Gnb 분기
			if (this.wW < 813 && this.wH < 482) {
				this.$store.state.gnbMode = "mobile";
			} else if (this.wH < 813 && this.wW < 482) {
				this.$store.state.gnbMode = "mobile";
			} else {
				this.$store.state.gnbMode = "pc";
			}
			console.log("this.$store.state.device:", this.$store.state.device);
		},
		onOrientationChange() {
			setTimeout(() => {
				this.wW = window.innerWidth;
				this.wH = window.innerHeight;
				if (this.wW < 813 && this.wH < 482) {
					this.$buefy.dialog.alert("모바일 세로 모드에 최적화 되있습니다.");
				}
			}, 300);
		},
		openGigaMenu: function() {
			this.gigaMenuActive = true;
		},
		checkGigaMenu(event) {
			if (event.target.tagName === "SELECT") return null;
			if (this.$store.state.gnbMode === "pc") {
				if (this.checkGigaHit(event.clientY)) {
					this.gigaMenuActive = true;
				} else {
					this.gigaMenuActive = false;
				}
				clearTimeout(this.gigiMenuSetTime);
				this.gigiMenuSetTime = setTimeout(() => {
					this.gigaMenuActive = false;
				}, 1800);
			} else {
				if (!this.checkGigaHit(event.clientY)) {
					this.gigaMenuActive = false;
				} else {
					var tg = event.target;
					if (
						tg.classList.contains("gnbSubMenuLink") ||
						tg.classList.contains("gnbMenu")
					) {
						this.gigiMenuSetTime = setTimeout(() => {
							this.gigaMenuActive = false;
						}, 400);
					}
				}
			}
		},
		checkGigaHit(currentY) {
			var gnbEl = document.getElementById("nav");
			var gnbH = gnbEl.clientHeight;
			var giga = document.querySelector("#nav .gigaMenu");
			var gigaH = giga.clientHeight;
			var clientY = currentY;

			if (
				(clientY > gnbH + gigaH && this.gigaMenuActive) ||
				(clientY > gnbH && !this.gigaMenuActive)
			) {
				return false;
			} else {
				return true;
			}
		},
		checkMousePos(event) {
			var eventDoc, doc, body;
			event = event || window.event;
			if (event.pageX == null && event.clientX != null) {
				eventDoc = (event.target && event.target.ownerDocument) || document;
				doc = eventDoc.documentElement;
				body = eventDoc.body;

				event.pageX =
					event.clientX +
					((doc && doc.scrollLeft) || (body && body.scrollLeft) || 0) -
					((doc && doc.clientLeft) || (body && body.clientLeft) || 0);
				event.pageY =
					event.clientY +
					((doc && doc.scrollTop) || (body && body.scrollTop) || 0) -
					((doc && doc.clientTop) || (body && body.clientTop) || 0);
			}

			return { x: event.pageX, y: event.pageY };
		}
	}
};
</script>

<style lang="scss">
@import "@/css/variables.scss";
@import "@/css/default.scss";
// Import Bulma's core
@import "~bulma/sass/utilities/_all";
$primary: #086db9;
$primary-invert: findColorInvert($primary);

$colors: (
	"white": (
		$white,
		$black
	),
	"black": (
		$black,
		$white
	),
	"light": (
		$light,
		$light-invert
	),
	"dark": (
		$dark,
		$dark-invert
	),
	"primary": (
		$primary,
		$primary-invert
	),
	"info": (
		$info,
		$info-invert
	),
	"success": (
		$success,
		$success-invert
	),
	"warning": (
		$warning,
		$warning-invert
	),
	"danger": (
		$danger,
		$danger-invert
	),
	"gray": (
		$c-blue-dgray,
		$c-gray-bright
	),
	"bright": (
		$c-gray-bright,
		$c-gray-light2
	)
);

// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";

#app {
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	color: #2c3e50;
}
#nav {
	$gnbItemW: 150px;
	$navH: 88px;
	z-index: 990;
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	background-color: #fff;
	height: $navH;
	box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
	.wrapGnbMenus {
		text-align: right;
		padding-top: 30px;
		.gnbMenu {
			display: inline-block;
			width: $gnbItemW * 2;
			color: #2c3e50;
			font-weight: bold;
			text-align: left;
			font-size: 20px;
			text-decoration: none;
			&:last-child {
				width: $gnbItemW;
			}

			&.router-link-exact-active {
				color: #086db9;
				text-decoration: underline;
			}
		}
	}
	.logo {
		position: absolute;
		left: 32px;
		top: 19px;
		opacity: 0;
		img {
			@include transition(0.4s);
			width: 214px;
		}
	}
	.buttons {
		display: none;
		position: absolute;
		right: 16px;
		top: 16px;
		&.mobile {
			display: block;
		}
	}
	.gigaMenu {
		@include transition(0.4s);
		display: block;
		overflow: hidden;
		top: $navH;
		position: absolute;
		z-index: 980;
		width: 100%;
		left: 0;
		background-color: rgba(255, 255, 255, 0.84);
		backdrop-filter: blur(6px) brightness(96%);
		height: 0;
		&.on {
			// height: 250px;
			height: auto;
			overflow-y: auto;
		}
		a {
			font-weight: normal;
			color: #344856;
			&.router-link-active {
				font-weight: bold;
			}
			&.router-link-exact-active {
				font-weight: bold;
			}
		}
		.home a {
			&.router-link-active {
				font-weight: normal;
			}
			&.router-link-exact-active {
				font-weight: bold;
			}
		}

		.menuListWrap {
			padding: 20px 0 30px;
			display: flex;
			justify-content: flex-end;
			text-align: left;
			> li {
				display: inline-block;
				h2 {
					@include offscreen;
				}
				&.home {
					@include offscreen;
				}
				&.company {
					.innerMenu {
						width: $gnbItemW * 2;
						display: flex;
						flex-wrap: wrap;
					}
				}
				.menuCategory {
					display: inline-block;
					vertical-align: top;
					h3 {
						line-height: 33px;
						font-weight: bold;
					}
					&.portfolio {
						color: $c-green;
						h3 {
							border-bottom: 1px solid $c-green;
							width: calc(100% - 20px);
							a {
								color: inherit;
								text-decoration: none;
								font-weight: bold;
							}
						}
					}
					&.solution {
						color: $c-blue;
						h3 {
							border-bottom: 1px solid $c-blue;
							width: calc(100% - 20px);
							a {
								color: inherit;
								text-decoration: none;
								font-weight: bold;
							}
						}
					}
				}
				.innerMenu {
					li {
						width: $gnbItemW;
						line-height: 34px;
						display: block;
						color: $c-gray-m;
						font-size: 18px;
						letter-spacing: $lspace-short;
					}
				}
				&.news .innerMenu {
					width: $gnbItemW * 2;
				}
			}
		}
	}
}
strong,
span.bold {
	color: inherit;
}
span.bold {
	font-weight: bold;
}

.page .secWrap {
	$navH: 88px;
	.topBgWrap {
		top: $navH;
	}
	.pageContentWrap {
		width: $mxW;
	}
}
.modal {
	z-index: 9900;
}
/*
	##Device = Laptops, Desktops
	##Screen = B/w 1025px to 1280px
*/
@media (min-width: 1025px) and (max-width: 1280px) {
	//CSS
	.page {
		.secWrap {
			.pageContentWrap {
				width: $mxWDTSmall - $scrW;
			}
		}
	}
	#nav {
		/* $gnbItemW: 140px; */
		$gnbItemW: 100px;
		.logo {
			position: absolute;
			left: 20px;
			top: 25px;
			img {
				width: 160px;
			}
		}
		.wrapGnbMenus {
			.gnbMenu {
				width: $gnbItemW * 2;
				&:last-child {
					width: $gnbItemW;
				}
			}
		}
		.gigaMenu {
			.menuListWrap {
				> li {
					&.company .innerMenu {
						width: $gnbItemW * 2;
					}
					&.news .innerMenu {
						width: $gnbItemW * 2;
					}
					.innerMenu {
						li {
							width: $gnbItemW;
							font-size: 17px;
						}
					}
				}
			}
		}
	}
}

/*
	##Device = Tablets, Ipads (portrait)
	##Screen = B/w 768px to 1024px
*/
@media (min-width: 768px) and (max-width: 1024px) {
	.page {
		.secWrap {
			.pageContentWrap {
				width: $mxWTablet - $scrW;
			}
		}
	}
	#nav {
		/* $gnbItemW: 112px; */
		$gnbItemW: 80px;
		.logo {
			position: absolute;
			left: 20px;
			top: 25px;
			img {
				width: 150px;
			}
		}
		.wrapGnbMenus {
			.gnbMenu {
				width: $gnbItemW * 2;
				font-size: 18px;
				&:last-child {
					width: $gnbItemW;
				}
			}
		}
		.gigaMenu {
			.menuListWrap {
				> li {
					&.company .innerMenu {
						width: $gnbItemW * 2;
					}
					&.news .innerMenu {
						width: $gnbItemW * 2;
					}
					.innerMenu {
						li {
							width: $gnbItemW;
							font-size: 17px;
						}
					}
				}
			}
		}
	}
}

/*
	##Device = Tablets, Ipads (landscape)
	##Screen = B/w 768px to 1024px
*/
@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
	//CSS
}

/*
	##Device = Low Resolution Tablets, Mobiles (Landscape)
	##Screen = B/w 481px to 767px
*/

@media (min-width: 481px) and (max-width: 767px) {
	//CSS
	$navH: 52px;
	.page {
		.secWrap {
			.topBgWrap {
				top: $navH;
			}
			.pageContentWrap {
				width: $mxWMobile;
			}
		}
		&.main {
			top: $navH !important;
			height: calc(100% - #{$navH}) !important;
		}
		&.news,
		&.industryTrends,
		&.portfolio,
		&.solution,
		&.customerService,
		&.error {
			padding-top: $navH !important;
		}
		.btnMore {
			height: 60px !important;
			font-size: $text-normal-small !important;
		}
	}
	#nav {
		height: $navH;
		.logo {
			left: 20px;
			top: 8px;
			img {
				width: 150px;
			}
		}
		.wrapGnbMenus {
			display: none;
		}
		.buttons {
			display: block;
			top: 1px;
			right: 1px;
		}
		.gigaMenu {
			$mobileGigaH: 520px;
			top: $navH;
			background-color: rgba($c-white, 0.92);
			box-shadow: 0px 2px 6px rgba($c-black, 0.32);
			&.on {
				height: $mobileGigaH;
			}
			.menuListWrap {
				position: absolute;
				display: block;
				overflow: auto;
				height: 90%;
				width: 90%;
				top: 5%;
				left: 10%;
				> li {
					margin-bottom: 20px;
					width: 100%;
					&.company {
						.innerMenu {
							width: 100%;
							li {
								width: 50%;
							}
						}
					}
					h2 {
						@include onscreen;
						display: block;
						font-size: $title-xsmall;
						font-weight: bold;
						margin-bottom: 5px;
					}
					.menuCategory {
						width: 50%;
						.innerMenu {
							width: 100%;
						}
					}
					.innerMenu {
						width: 100%;
						li {
							line-height: 28px;
						}
					}
				}
			}
		}
	}
}

/*
	##Device = Most of the Smartphones Mobiles (Portrait)
	##Screen = B/w 320px to 479px
*/
@media (min-width: $mnWMobile) and (max-width: 480px) {
	//CSS
	$navH: 52px;
	.page {
		.secWrap {
			.topBgWrap {
				top: $navH;
			}
			.pageContentWrap {
				width: $mxWMobile;
			}
		}
		&.main {
			top: $navH !important;
			height: calc(100% - #{$navH}) !important;
		}
		&.news,
		&.industryTrends,
		&.portfolio,
		&.solution,
		&.customerService,
		&.error {
			padding-top: $navH !important;
		}
		.btnMore {
			height: 60px !important;
			font-size: $text-normal-small !important;
		}
	}
	#nav {
		height: $navH;
		.logo {
			left: 20px;
			top: 9px;
			img {
				width: 150px;
			}
		}
		.wrapGnbMenus {
			display: none;
		}
		.buttons {
			display: block;
			top: 1px;
			right: 1px;
		}
		.gigaMenu {
			/* $mobileGigaH: 440px; */
			$mobileGigaH: 464px;
			top: $navH;
			background-color: rgba($c-white, 0.92);
			box-shadow: 0px 3px 6px rgba($c-black, 0.08);
			&.on {
				height: $mobileGigaH;
			}
			.menuListWrap {
				position: absolute;
				display: block;
				overflow: auto;
				height: 90%;
				width: 93%;
				padding: 0 0 10px;
				top: 4%;
				left: 7%;
				> li {
					margin-bottom: 8px;
					&.home {
						display: block;
					}
					h2 {
						@include onscreen;
						display: block;
						font-size: $title-xsmall;
						font-weight: bold;
						margin-bottom: 4px;
					}
					.innerMenu li {
						line-height: 28px;
					}
					.menuCategory {
						width: calc(50% - 10px);
					}
				}
			}
		}
	}
}
</style>
